// colors
import { colors } from '../../../../packages';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  drawer: {
    '& .MuiPaper-root': {
      maxWidth: '640px !important',
    },
    '& .drawerBody': {
      minHeight: 'calc(100vh - 80px)',
      flexDirection: 'column',
      display: 'flex',
      padding: 0,
    },
  },
  top: {
    backgroundColor: colors.neutral50,
    padding: 32,
  },
  amount: {
    fontSize: 96,
    lineHeight: '104px',
    fontWeight: 600,
    fontFamily: 'Source Serif Pro',
    margin: 0,
  },
  time: {
    fontSize: 16,
    lineHeight: '24px',
    color: colors.neutral600,
    margin: 0,
  },
  item: {
    flex: 1,
  },
  status: {
    borderRadius: 100,
    minWidth: 'auto',
    height: 24,
    fontSize: 14,
    color: colors.success500,
    marginBottom: 10,
  },
  unpaidStatus: {
    color: `${colors.destructive500} !important`,
  },
  member: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    minHeight: 40,
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
  },
  id: {
    fontFamily: 'Manrope',
    fontSize: 14,
    // lineHeight: '10px',
    color: colors.neutral900,
  },
  name: {
    fontFamily: 'Manrope',
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral600,
  },
  infoWrap: {
    display: 'flex',
    alignItems: 'center',
    padding: 32,
    justifyContent: 'space-between',
    borderTop: `1px solid ${colors.neutral100}`,
  },
  infoBlock: {
    flex: 1,
  },
  infoBlockLabel: {
    fontWeight: 800,
    fontSize: 12,
    lineHeight: '20px',
    textTransform: 'uppercase',
    color: colors.neutral600,
    margin: 0,
    // marginBottom: 8,
    display: 'block',
  },
  infoBlockAdditionalLabel: {
    fontWeight: 800,
    fontSize: 12,
    // lineHeight: '20px',
    textTransform: 'uppercase',
    color: colors.neutral600,
    margin: 0,
    marginTop: 8,
    // marginBottom: 8,
    display: 'block',
  },
  roleBadge: {
    borderRadius: 20,
    whiteSpace: 'nowrap',
    height: 18,
    padding: '2px 8px',
    fontSize: 12,
    width: 'fit-content',
    border: 'none',
    marginTop: 2,
    '&.Provider': {
      backgroundColor: colors.indigo50,
      color: colors.indigo600,
    },
    '&.Coach': {
      backgroundColor: colors.warning50,
      color: colors.warning600,
    },
    '&.Prescriber': {
      backgroundColor: colors.cyan50,
      color: colors.cyan600,
    },
    '&.Matchmaker': {
      backgroundColor: '#FEF6EE',
      color: '#E04F16',
    },
    '&.Socialworker': {
      backgroundColor: colors.purple50,
      color: colors.purple600,
    },
  },
});
